import styled from "styled-components";

export const FooterWrapper = styled.div`
    position: absolute;
    bottom: 0;
    right: 0;
    left: 0;
    width: 100%;
    padding: 16px 20px 40px 20px;
    gap: 12px;
    box-shadow: 0px -1.2px 3.6px 0px #0000001C;
    background-color: ${(props) => props.theme.serviceDeskMobileFooterBackground};
    display: flex;
    flex-direction: row-reverse;
`;